<template>
  <div class="list_ruangan">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-snackbar v-model="showSnack" multi-line="true" top="true" color="red">
              {{ msg }}
              <v-btn color="pink" flat @click="showSnack = false">Tutup</v-btn>
            </v-snackbar>

            <v-card-title>
              <h3>
                <b>Laporan Penggunaan Ruangan</b>
              </h3>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form class="px-3">
                <v-select
                  name="lokasi"
                  label="Lokasi"
                  :items="listOfLokasi"
                  v-model="idLokasi"
                  @change="onLokasi"
                ></v-select>
                <v-select
                  name="gedung"
                  label="Gedung"
                  :items="listOfGedung"
                  v-model="idGedung"
                  @change="onGedung"
                ></v-select>
                <v-select
                  name="ruangan"
                  label="Ruangan"
                  :items="listOfRuangan"
                  v-model="form.idRuangan"
                ></v-select>
                <v-select
                  name="jenis_kegiatan"
                  label="Jenis Kegiatan"
                  :items="jenisKegiatan"
                  v-model="form.jenisKegiatan"
                ></v-select>

                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.startDate"
                      label="Tanggal Awal"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.startDate" @input="menu1 = false"></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.endDate"
                      label="Tanggal Akhir"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.endDate" @input="menu2 = false"></v-date-picker>
                </v-menu>

                <v-spacer></v-spacer>

                <v-card-actions class="justify-center">
                  <v-btn
                    class="btn-simpan"
                    color="blue"
                    dark
                    style="width:120px;"
                    @click="onGenerate"
                  >
                    <v-icon left>fa fa-check</v-icon>Generate
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
       
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { base, fileUrl } from "../../setup-axios"
import {createJWT} from "../../store/module/helper";

export default {
  data() {
    return {
      role: localStorage.getItem("role"),
      msg: "",
      showSnack: false,
      menu: false,
      modal: false,
      menu1: false,
      menu2: false,
      listOfGedung: [],
      listOfLokasi: [],
      listOfRuangan: [],
      jenisKegiatan: [],
      idLokasi: null,
      idGedung: null,
      form: {
        idRuangan: null,
        jenisKegiatan: null,
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10)
      }
    }
  },
  created() {
    base.get("lokasi/dropdown",
           {
             headers: {
               Authorization: createJWT()
             }
           }).then(resp => {
      for (var i = 0; i < resp.data.result.length; i++) {
        this.listOfLokasi.push({ value: resp.data.result[i].id, text: resp.data.result[i].nama })
      }
    }),
      this.setJenisKegiatan()
  },
  methods: {
    onGenerate() {
      if (this.validateEmptyFile()) {
        base.post("/penggunaanRuangan/report", this.form,
           {
             headers: {
               Authorization: createJWT()
             }
           }).then(resp => {
          let ticket = resp.data.ticket
          console.log("get ticket:  " + ticket)
          window.location =
            fileUrl +
            "penggunaanRuangan/report/" +
            this.form.idRuangan +
            "/" +
            this.form.jenisKegiatan +
            "/" +
            this.form.startDate +
            "/" +
            this.form.endDate +
            "?ticket=" +
            ticket
        })
      }
    },
    onLokasi() {
      base
        .get("gedung/lokasi/" + this.idLokasi)
        .then(resp => {
          for (var i = 0; i < resp.data.result.length; i++) {
            this.listOfGedung.push({ value: resp.data.result[i].id, text: resp.data.result[i].nama })
          }
        })
        .catch(function(error) {
          console.log("ERROR : ", error)
        })
    },
    onGedung() {
      base
        .get("ruangan/dropdown/byGedung/" + this.idGedung)
        .then(resp => {
          for (var i = 0; i < resp.data.result.length; i++) {
            this.listOfRuangan.push({ value: resp.data.result[i].id, text: resp.data.result[i].nama })
          }
        })
        .catch(function(error) {
          console.log("ERROR : ", error)
        })
    },
    setJenisKegiatan() {
      if (this.role == "ruang") {
        this.jenisKegiatan = new Array("Akademik")
      } else if (this.role == "RT") {
        this.jenisKegiatan = new Array("Non-Akademik")
      } else {
        this.jenisKegiatan = new Array("Semua", "Akademik", "Non-Akademik")
      }
    },
    validateEmptyFile() {
      var isValid = true
      var emptyField = []
      var validationMessage = ""
      if (this.form.idRuangan == null) {
        isValid = false
        emptyField.push("Ruangan")
      }
      if (this.form.startDate == null) {
        isValid = false
        emptyField.push("Tanggal Awal")
      }
      if (this.form.endDate == null) {
        isValid = false
        emptyField.push("Tanggal Akhir")
      }
      if (this.form.jenisKegiatan == null) {
        isValid = false
        emptyField.push("Jenis Kegiatan")
      }

      if (!isValid) {
        for (let i = 0; i < emptyField.length; i++) {
          validationMessage += emptyField[i]
          if (i + 1 != emptyField.length) {
            validationMessage += ", "
          }
        }

        this.showSnack = true
        this.msg = validationMessage + " harus di isi!"
      }

      return isValid
    }
  }
}
</script>
